import { Row, theme, Typography } from "antd";

interface PageHeaderProps {
  readonly title: string;
  readonly stage?: number;
  readonly icon: React.ReactNode;
}

function PageHeader(props: PageHeaderProps) {
  const { token } = theme.useToken();
  return (
    <Row className="items-center justify-center gap-2 bg-[#056159] py-4">
      {props.stage && (
        <Typography.Title
          level={2}
          className="m-0 tracking-tight"
          style={{ color: "white", fontFamily: token.fontFamily }}
        >
          {`STAGE ${props.stage} `}
        </Typography.Title>
      )}
      <div className="ml-20">{props.icon}</div>
      <Typography.Title
        level={2}
        className="m-0 tracking-tight"
        style={{ color: "white", fontFamily: token.fontFamily }}
      >
        {props.title.toUpperCase()}
      </Typography.Title>
    </Row>
  );
}

export default PageHeader;
